import type { PreferencesFormValues } from './../types'
import { useMemo } from 'react'

import { form } from './formState'
import { FormConfig } from '@workwave-tidal/core/form'

import { useTexts } from '../hooks/useTexts'
import { FormFooter } from './FormFooter'
import { PreferencesFormProps as Props } from './../types'
import { CompanyFromName } from './fields/CompanyFromName'
import { DateFormat } from './fields/DateFormat'
import { TimeFormat } from './fields/TimeFormat'
import { NotificationLanguage } from './fields/NotificationLanguage'
import { OverrideSenderName } from './fields/OverrideSenderName'
import { useOnSubmit } from './hooks/useOnSubmit'

export function PreferencesForm(props: Props) {
  const { supportedLanguages, formValues } = props

  const onSubmit = useOnSubmit()
  const texts = useTexts()

  const config = useMemo<FormConfig<PreferencesFormValues>>(
    () => ({
      id: 'preferences-form',
      initialValues: formValues,
    }),
    [formValues],
  )

  return (
    <form.Form
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      footer={<FormFooter />}
      onSubmit={onSubmit}
      config={config}
      requireTransaction={false}
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
      testId="preferences-form"
      width={442}
    >
      <NotificationLanguage supportedLanguages={supportedLanguages} />
      <CompanyFromName />
      <OverrideSenderName />
      <TimeFormat />
      <DateFormat />
    </form.Form>
  )
}
